import React from "react";
import PropTypes from "prop-types";

import Button from "../Components/Button";

export default class ProductPage extends React.Component {
    render(){
        const productPageLink = `/product/${this.props.identifier}`;

        return(
            <a title={this.props.title} className="category-card-container" href={productPageLink}>
                <div className="category-card">
                    <div className="card card-hover">
                        <img className="card-img-top" src={`${localStorage.getItem("restUrl")}/pub/media/wysiwyg/landing-page/${this.props.layout_file}`} onError={this.addDefaultSrc}/>
                        <div className="card-body product-widget-body">
                            <a className="card-title" href={productPageLink}>{this.shorten(this.props.title, 35)}</a>
                            {/*<p className="text-center text-danger"> 51 Available</p>*/}
                            <Button className="btn btn-lx btn-lx-sm" label="View Details" />
                        </div>
                    </div>
                </div>
            </a>

        );
    }
    addDefaultSrc(e){
        e.target.src = "/images/image-not-found.png";
    }
    shorten(title, max, separator = " ") {
        if (title.length <= max){
            return title;
        } else {
            return title.substr(0, title.lastIndexOf(separator, max));
        }
    }
}

ProductPage.propTypes = {
    title: PropTypes.string,
    identifier: PropTypes.string,
    layout_file: PropTypes.string
};
